module.exports = __webpack_public_path__ + "static/media/DaRumble.41f22f4a.png";